import { difference, includes } from "lodash";

/**
 * GraphQL `FormQuestionCondition` uses `type: string`; only `"includes"` is implemented here.
 */
type PassesCondInput = { type: string; values: readonly unknown[] } | null | undefined;

/**
 * Whether a conditional question should apply its validators, given the parent field value.
 * Used by {@link ./validations} with Yup `.when()`.
 */
export const passesForCond = (cond: PassesCondInput, value: unknown): boolean => {
  if (cond === null || typeof cond === "undefined") return true;

  const { type, values } = cond;
  if (type === "includes") {
    // Yup 1 passes single-field `.when()` deps as one-element arrays (e.g. `["true"]`). Unwrap
    // only when the condition lists a single expected value, so partial multi-select answers
    // like `["a"]` vs `["a","b"]` still use array semantics.
    const unwrapSingleton =
      Array.isArray(value) &&
      value.length === 1 &&
      Array.isArray(values) &&
      values.length === 1;
    const resolved = unwrapSingleton ? value[0] : value;

    return (
      (Array.isArray(resolved) &&
        difference(values as unknown[], resolved as unknown[]).length === 0) ||
      includes(values as unknown[], resolved) ||
      includes(values as unknown[], JSON.stringify(resolved))
    );
  }
  return false;
};
